
export default {

  // API URLS APPORTED BY ENVIRONMENT VARIALBES
  BASE_URL: process.env.VUE_APP_BASE_URI,   // http://{{url}}
  API_URL: process.env.VUE_APP_API_URI,    // http://{{url}}/api/
  BASE_WEB: process.env.VUE_APP_WEB
}